import React, { useRef, useMemo } from 'react'
import DailyGraphRect from './DailyGraphRect'
import moment from 'moment'
import R from 'ramda'
import * as d3 from 'd3'
import SolarGenerationRect from './SolarGenerationRect'
import PieCircleGraph from './SolarPieCircleGraph'

const DailyGraph = ({
  data,
  date,
  limit = 0,
  totalWidth,
  generationData = [],
  totalHeight = 150,
  isValid = true,
  pieCircleGraph = [],
  inverterLimit = 0,
  ...props
}) => {
  const warningLine = limit - 20
  const graphDivRef = useRef()
  const svgMonthlygraph = useRef()
  // const perfDisplayGridRef = useRef()

  // const width = 400
  const tickHeight = 30
  const height = totalHeight - tickHeight
  // const displayLimit = formatNumber('0.0')(parseFloat(limit || 0))

  const margin = 0

  //   const sizeByClientSpecific = props.actionPermits.find(
  //     f => f.indexOf('MONTHLY_VIEW_GRAPH_SIZE') === 0
  //   )
  //   if (sizeByClientSpecific) {
  //     const widthBySize = sizeByClientSpecific.substring(
  //       sizeByClientSpecific.lastIndexOf('_') + 1
  //     )
  //     width = parseFloat(widthBySize)
  //   }

  //   const editable = useMemo(
  //     _ => {
  //       const monthlyViewPermission = hasAccesPermits({
  //         authGodMode: false,
  //         actionPermits: props.actionPermits,
  //         eventActions: [ScreenPermissions.MONTHLY_OPERATION_SAVE_PERF_DATA],
  //         matchAny: true,
  //       })

  //       if (!monthlyViewPermission) return false

  //       if (props.isAdminTypeUser) return true

  //       if (props.lock === 'L') return false

  //       return true
  //     },
  //     [props.actionPermits, props.isAdminTypeUser, props.lock]
  //   )

  const days = parseInt(
    moment(date)
      .endOf('month')
      .format('DD')
  )

  const minusWidth = 0

  // endPct is in % so domain is 0 to 100
  const yScale = useMemo(
    _ =>
      d3
        .scaleLinear()
        .range([height - margin, 0])
        .domain([0, 100]),
    // .domain([0, limit]),
    // .nice()
    [height]
  )
  const totalHourWidth = R.range(0, days + 1)
    .map(_ => 45)
    .reduce((a, b) => a + b)

  const width = totalWidth

  const xScale = useMemo(
    _ =>
      d3
        .scaleLinear()
        // .range([0, width - 100])
        .range([0, totalHourWidth])
        .domain([1, days + 1]),
    // .padding(0)
    [totalHourWidth, days]
  )

  // const xMonthlyScale = {
  //   bandwidth: _e => (xScale ? xScale(2) - xScale(1) : '0'),
  // }

  // const bw = xMonthlyScale ? xMonthlyScale.bandwidth() : 10

  // const totalHourWidth = `${R.range(0, days + 1).reduce((a, _b) => a + bw)}`

  const traslateWidth = 10

  if (svgMonthlygraph.current) {
    // const svg = d3.select(svgMonthlygraph.current)
    const ticks = d3.select('#tick')
    ticks.selectAll('#xid').remove()

    ticks
      .append('g')
      .attr('id', 'xid')
      .attr(
        'transform',
        'translate(' + traslateWidth + ',' + (height + margin) + ')'
      )
      .call(
        d3
          .axisBottom(xScale)
          .tickValues(R.range(1, days + 1))
          .tickFormat(i => (i === 0 ? '' : i))
      )
  }

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: '50px auto 50px 110px',
        gap: 5,
      }}
    >
      <div style={{ marginRight: '5px' }}>
        <svg style={{ width: '50px', height: '150px' }}>
          <text x={20} y={40}>
            MW
          </text>

          <g>
            <text x={20} y={125}>
              0
            </text>

            <text x={0} y={10}>
              {isNaN(limit) ? 0 : parseInt(limit) + 1}
            </text>

            <polyline
              fill="none"
              stroke="black"
              // points={`${xScale(0) - 10},${yScale(0) - 10} ${xScale(
              //   0
              // )},${yScale(0) - 10} ${xScale(0)},${yScale(100) - 5} ${xScale(0) -
              //   10},${yScale(100) - 5}`}
              points="40,3 50,3 50,120 30,120"
            />
          </g>
        </svg>
      </div>
      <div
        ref={graphDivRef}
        style={{
          // gridColumnEnd: 'span 1',
          overflowX: 'auto',
          maxWidth: width - minusWidth - 100,
          overflowY: 'hidden',
          height: totalHeight,
          display: 'grid',
          // gridTemplateColumns: width - minusWidth - 100,
        }}
        // onScroll={() => {
        //   if (dailyRef.current) {
        //     dailyRef.current.scrollLeft = graphDivRef.current.scrollLeft
        //   }
        //   if (hourRef.current)
        //     hourRef.current.scrollLeft = graphDivRef.current.scrollLeft
        //   if (perfDisplayGridRef.current) {
        //     perfDisplayGridRef.current.scrollLeft =
        //       graphDivRef.current.scrollLeft
        //   }
        // }}
      >
        <svg
          ref={svgMonthlygraph}
          style={{
            // backgroundColor: 'yellow',
            height: totalHeight,
            // paddingBottom: '-10px',
            // width: `${R.range(0, days + 1).reduce((a, _b) => a + bw)}px`,
            width: `${totalHourWidth}px`,
          }}
        >
          <defs>
            <linearGradient
              id="ReflectGradient"
              spreadMethod="reflect"
              x1="20%"
              x2="10%"
            >
              <stop offset="0%" stopColor="#ffc0cb52" />
              <stop offset="100%" stopColor="#ce324d45" />
            </linearGradient>
          </defs>
          <g id="tick" />
          <g id="barchart">
            <DailyGraphRect
              xScale={xScale}
              yScale={yScale}
              limit={parseFloat(limit)}
              margin={margin}
              height={totalHeight - 10}
              days={days}
              data={data}
              traslateWidth={traslateWidth}
              {...props}
            />
          </g>
          <g id="generation-rect">
            <SolarGenerationRect
              xScale={xScale}
              yScale={yScale}
              limit={parseFloat(limit)}
              margin={margin}
              height={totalHeight - 10}
              days={days}
              data={generationData}
              traslateWidth={traslateWidth}
              {...props}
            />
          </g>
          <g id="20mw">
            {warningLine > 0 && limit > 0 && (
              <line
                x={xScale(1)}
                x2={xScale(days + 1)}
                y1={yScale((warningLine * 100) / limit)}
                y2={yScale((warningLine * 100) / limit)}
                stroke="black"
                strokeDasharray="4 2"
                strokeWidth={0.5}
              />
            )}
          </g>
        </svg>
      </div>
      <div
        style={{
          marginRight: '5px',
          width: '50px',
          height: '150px',
          zIndex: 1000,
        }}
      >
        <svg style={{ width: '80px', height: '150px' }}>
          {isValid && (
            <text x={5} y={40}>
              MWh
            </text>
          )}
          <g>
            <text x={20} y={125}>
              0
            </text>

            <text x={20} y={10}>
              {isNaN(inverterLimit) ? 0 : parseInt(inverterLimit) + 1}
            </text>

            <polyline
              fill="none"
              stroke="black"
              points="10,5 0,5 0,120 10,120"
            />
          </g>
        </svg>
      </div>
      <PieCircleGraph data={pieCircleGraph} />
    </div>
  )
}

export default DailyGraph
